// extracted by mini-css-extract-plugin
export default {"base":"base__style__WwaQl","content":"content__style__hVQay","logo":"logo__style__WCkIY","message":"message__style__t_DdC","actions":"actions__style__Lb69f"};